<!--
입력 폼
--------------------------
옵션
    id : id 속성
    name : name 속성
    label : 라벨
    label-visibility : 라벨 표시여부
    init-val : 초기 값
    placeholder : 플레이스홀더
    init-error-msg : 초기 오류메세지
    desc-msg : 설명
    options : 셀렉트박스, 체크, 라디오 에서 사용
        ex ) :options="[{text: '선택안함', val: 9}, {text: '개인통관고유부호', val: 1, selected: true}]"
    textarea-rows : TEXTAREA 인경우, rows 속성
    validate-rules : 검증규칙
        ex) :validate-rule="{required: true, title: 'title'}" // 검증규칙 객체를 넘기는 경우
        ex) validate-rule="func_name" //  프라미스 생성 함수명을 넘기는 경우

    input-size : input 요소 사이즈
    required : 필수값 여부
    required-text : 필수표시 텍스트
    required-layout : 필수표시 위치

-->
<template>
    <div :class="classObject">
        <label
            v-if="label"
            v-visible="isLabelVisible"
            :for="elem_id"
            class="uk-form-label"
            :class="labelSizeClass"
            @click="setFocus"
        >

            <div class="" >
                <!-- 필수 -->
                <span v-if="required && requiredLayout === 'label-left'" class="uk-text-meta">{{ requiredText }}</span>

                {{ label }}

                <!-- 필수 -->
                <sup v-if="required && requiredLayout === 'label-right-sup'" class="uk-text-muted">{{ requiredText }}</sup>

                <!-- 검증상태 -->
                <span class="validate-state-sign" v-show="validateState === 'success'" uk-icon="icon: check"></span>
            </div>

            <slot name="label-desc">
                <!-- 라벨 우측 설명 -->
            </slot>
        </label>

        <div class="uk-form-controls">

            <div uk-form-custom v-if="type=='print'" class="print_place">
                {{ val }}
                <slot name="after_print"></slot>
            </div>

            <input
                v-if="type=='text'"
                type="text"
                class="uk-input"
                :class="[inputSizeClass,inputClass]"
                :id="id"
                :name="name"
                :placeholder="placeholder"
                v-model.trim="val"
                v-on:focus="focus"
                v-on:focusout="focusout"

                :disabled="disabled"
                :readonly="readonly"
            />

            <input
                v-if="type=='password'"
                type="password"
                class="uk-input"
                :class="[inputSizeClass,inputClass]"
                :id="id"
                :name="name"
                :placeholder="placeholder"
                v-model.trim="val"
                v-on:focus="focus"
                v-on:focusout="focusout"
            />

            <div
                v-if="type=='radio'"
                class="uk-grid-small uk-child-width-auto uk-grid"
            >
                <label v-for="option in options">
                    <input
                        class="uk-radio"
                        :class="[inputSizeClass,inputClass]"
                        type="radio"
                        :name="name"
                        :value="option.val"
                        v-model.trim="val"
                    >
                    {{ option.text }}
                </label>
            </div>


            <div
                v-if="type=='checkbox'"
                class="uk-grid-small uk-child-width-auto uk-grid"
            >
                <label v-for="option in options">
                    <input
                        class="uk-checkbox"
                        :class="[inputSizeClass,inputClass]"
                        type="checkbox"
                        :name="name"
                        :value="option.val"
                    >
                    {{ option.text }}
                </label>
            </div>

            <select
                v-if="type=='select'"
                :name="name"
                class="uk-select"
                :class="[inputSizeClass,inputClass]"
            >
                <option
                    v-for="option in options"
                    :value="option.val"
                    :selected="option.selected === true"
                >
                    {{ option.text }}
                </option>
            </select>


            <textarea
                v-if="type=='textarea'"
                class="uk-textarea"
                :class="[inputSizeClass,inputClass]"
                :id="id"
                :name="name"
                :placeholder="placeholder"
                v-model.trim="val"
                v-on:focus="focus"
                v-on:focusout="focusout"
                :rows="textareaRows"
            ></textarea>

            <!-- 필수 -->
            <sup v-if="required && requiredLayout === 'input-bottom'" class="uk-text-muted">{{ requiredText }}</sup>

            <!-- 하단 추가설명 영역 -->
            <slot name="input-bottom">

            </slot>
        </div>


        <!-- 에러메세지 -->
        <div v-show="errorMsg" class="error-msg uk-text-small">
            {{ errorMsg }}
        </div>

        <!-- 설명메세지 -->
        <div v-show="descMsg" class="desc-msg uk-text-small">
            {{ descMsg }}
        </div>


    </div>
</template>

<script>
// 검증모듈 로드
let approve = require('approvejs').default;

export default {
    props: {
        type: String,
        id: String,
        name: String,
        label: String,
        placeholder: String,
        initErrorMsg: String,
        descMsg: String,
        initVal: String,
        labelVisibility: String, // 라벨의 visibile 타입을 결정 auto : val 속성에 의해 컨트롤 , visible(기본값) : 항상 표시, hidden : 항상 숨김

        // 셀렉트 박스나, 라디오에서 사용할 옵션객체 배열 ex) [{text: '텍스트', val: 'a'}, {text: 'b', val: 'c'}]
        // 셀렉트 박스 or 체크박스 선택 ex ) [{text: '텍스트', val: 'a'}, {text: 'b', val: 'c', selected: true}]
        options: Array,
        textareaRows: { // TEXTAREA 의 rows 속성
            type: Number,
            default: 5
        },

        /**
         * 검증규칙
         *      - 검증규칙객체 : approvejs
         *        참고 ) https://charlgottschalk.github.io/approvejs/docs/tests/
         *      - 검증 Promise 생성 콜백 함수명
         *        function callback(cmp) { return Promise}
         **/
        validateRules: {
            default: null
        },
        /**
         * input 요소에 직접 바인딩되는 클래스명
         * */
        inputClass: {
            type: String,
            default: null
        },
        /**
         * input 요소 사이즈
         *  - small
         *  - large
         * */
        inputSize: {
            type: String,
            default: null
        },
        /**
         * 필수값 여부
         * */
        required: {
            type: Boolean,
            default: false
        },
        /**
         * 필수값 안내 텍스트
         * */
        requiredText: {
            type: String,
            default: '*'
        },
        /**
         * 필수값 안내 위치
         *  - 'label-left' : 라벨 왼쪽
         *  - 'label-right-sup' : 라벨 우측 위로 조그맣게
         *  - 'input-bottom' : input 요소 밑에
         * */
        requiredLayout: {
            type: String,
            default: 'label-right-sup'
        },


        /**
         * disabled
         * */
        disabled: {
            type: Boolean,
            default: false
        },
        /**
         * readonly
         * */
        readonly: {
            type: Boolean,
            default: false
        },

    },
    data: function () {

        return {
            val: this.initVal, // 값
            validateState: this.initErrorMsg ? 'error' : 'none', // 검증 처리 상태, ing : 검증중, success : 성공, error : 오류
            errorMsg: this.initErrorMsg,
            isFocus: false

        };
    },
    computed: {
        elem_id: function () {
            let id = _.trim(this.$props.id);
            return (id) ? id : this.get_cmp_id();
        },
        labelSizeClass: function () {
            if (this.inputSize === 'small') {
                return 'label-small';
            } else if (this.inputSize === 'large') {
                return 'label-large';
            }
            return '';
        },
        inputSizeClass: function () {
            if (this.inputSize === 'small') {
                return 'uk-form-small';
            } else if (this.inputSize === 'large') {
                return 'uk-form-large';
            }
            return '';
        },
        isLabelVisible: function () { // 라벨의 visible 여부를 리턴
            if (this.labelVisibility == 'visible') {
                return true;
            } else if (this.labelVisibility == 'hidden') {
                return false;
            } else if (this.labelVisibility == 'auto') {
                //return this.val || this.type=='print';
                return this.val;
            }
            return true;
        },
        /**
         * 클래스
         * */
        classObject: function () {
            return {
                'focus': this.isFocus,
                'validate-error': this.validateState === 'error',
                'validate-ing': this.validateState === 'ing',
                'validate-success': this.validateState === 'success'
            }
        },
        /**
         * 검증 등록 여부
         * */
        hasValidation: function () {
            //console.log(this.validateRules);
            // 검증규칙있으면 실행
            if (this.validateRules) {
                return true;
            } else {
                return false;
            }
        },
        /**
         * 라이브 검증 실행여부
         * */
        isOnLiveValidate: function () {
            return this.hasValidation; // 검증이 등록되면 무조건 라이브검증 실행
        }
    },
    watch: {
        /**
         * 값이 변경되는 것을 감시해서, 라이브 검증 처리
         * - lodash 의 debounce() 기능을 통해서, 지정된 시간내에 재 입력이 일어나면 입력이 다 끝난 후 한번만 호출
         */
        val: function () {
            //this.$emit('changed', this);

            // 라이브검증 설정 되어있을때만 검증실행
            if (this.isOnLiveValidate) {
                this.validate();
            }


        }
    },
    methods: {
        focus: function () {
            this.isFocus = true;
        },
        focusout: function () {
            this.isFocus = false;
        },
        /**
         * 현재 컴포넌트의 input 요소에 포커스를 준다.
         * */
        setFocus: function () {
            $(this.$el).find(':input').focus();
        },
        /**
         * 검증상태를 오류상태로 설정한다.
         */
        setError: function (msg) {
            if (!msg) {
                msg = '';
            }
            this.errorMsg = msg;
            this.validateState = 'error';
        },
        /**
         * 검증 처리 Promise를 반환
         **/
        getValidatePromise: function () {
            let cmp = this; // 뷰 컴포넌트 객체
            let rules = cmp.validateRules;


            // 프라미스 생성
            let promise = null;
            if ($.type(rules) == 'string') {
                // 함수명인 경우
                promise = $.app.util.call_func(rules, window, cmp);

            } else {
                // 검증 규칙 객체인 경우

                promise = new Promise(function (resolve, reject) {
                    // 검증
                    if (!rules.title) rules.title = cmp.label;
                    let result = approve.value(cmp.val, rules);

                    // 검증 결과처리
                    if (result.approved) {
                        resolve();
                    } else {
                        reject(result.errors[0]);// 첫번째 오류메세지 설정
                    }


                });
            }
            return promise;

        },
        /**
         * 검증 실행
         */
        validate: _.debounce(function () {
            // 검증이 등록 안되어있으면 종료
            if (!this.hasValidation) {
                return;
            }

            let cmp = this; // 뷰 컴포넌트 객체
            let value = cmp.val; // 검증이 이루어질 값, 추후에 검증과정중에 값이 변경되었는지 검사함.

            // 검증중 이면 먼저 검증이 끝날때까지 검증안함.
            if (this.validateState === 'ing') {
                return;
            }
            this.validateState = 'ing';


            // 오류메세지 초기화
            this.errorMsg = '';

            // 검증 프라미스 실행
            let promise = this.getValidatePromise();
            promise.then(function () {
                // resolve
                cmp.validateState = 'success';
                //console.log('success');

            }, function (reason) {
                // reject
                cmp.setError(reason);
                //console.log('error');

            }).finally(function () {
                //console.log('finally');
                // 검증이 실행되는동안 값이 변경되었으면 검증을 다시 실행
                if (value !== cmp.val) {
                    cmp.validate();
                }

            });

        }, 500)
    }
}
</script>

<style lang="scss" scoped>
.error-msg {
    color: #f0506e !important;
    text-align: right;
}

.desc-msg {
    color: #999 !important;
    text-align: right;
}

label {
    font-size: 1.125rem;
}

.uk-form-controls {
    span {
        margin-top: 7px;
    }

    div.print_place {
        margin-top: 7px;
    }
}

.validate-ing { // 검증-중 상태
    label {
        //color: #666;
        .validate-state-sign {
            color: #666;
        }
    }

    input, select, textarea {
        border-color: #666;
    }
}

.validate-success { // 검증-성공 상태
    label {
        //color: #009a67;
        .validate-state-sign {
            color: #009a67;
        }
    }

    input, select, textarea {
        border-color: #009a67;
    }
}

.validate-error { // 검증-오류 상태
    input, select, textarea {
        border-color: #f0506e;
    }
}

.focus { //포커싱 상태
    label {
        color: #1e87f0;
    }

    input, select, textarea {
        border-color: #1e87f0;
    }
}
.uk-form-label {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

}

// 라벨 사이즈
.uk-form-horizontal .uk-form-label {
    &.label-small {
        margin-top: 3px
    }

    &.label-large {
        margin-top: 15px
    }
}


</style>